<template>
    <!--弹窗-->
    <el-dialog width="70%" title="运营asin列表" :visible.sync="visible" :before-close="handleClose">
        <el-button type="success" @click="showInner(1)" size="mini" v-show="showEdit">添加</el-button>
        <el-select v-model="query.status" placeholder="状态" size="mini" style="margin-left: 10px">
            <el-option label="全部" value=""></el-option>
            <el-option label="运营中" :value="1"></el-option>
            <el-option label="不再运营" :value="-1"></el-option>
        </el-select>
        <el-button type="primary" size="mini" icon="search" @click="getCategoryList" style="margin-left: 10px">查询
        </el-button>

        <el-table
            :row-key="getRowKeys"
            v-loading="loading"
            :data="list"
            class="table_content"
            size="mini"
            border
            height="400"
            style="width: 100%; margin-top: 10px">
            <el-table-column
                label="ID"
                :resizable="false"
                prop="id"
                align="center">
            </el-table-column>
            <el-table-column
                label="asin"
                :resizable="false"
                prop="asin"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="创建时间"
                :resizable="true"
                prop="create_time"
                align="center">
            </el-table-column>

            <el-table-column label="运营状态" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row.operation_status == 1 ? '运营中' : '不再运营'}}</div>
                </template>
            </el-table-column>

            <el-table-column
                min-width="140"
                label="不再运营时间"
                :resizable="true"
                prop="operation_no_time"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="不再运营原因"
                :resizable="true"
                prop="operation_no_season"
                align="center">
            </el-table-column>

<!--            <el-table-column label="操作" :width="showEdit ? 250 : 0" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini"-->
<!--                               @click="noActiveList(scope.row)" v-show="scope.row.status == 1">-->
<!--                        不再运营-->
<!--                    </el-button>-->
<!--                    <el-button type="primary" @click="showInner(2, scope.row)" size="mini">修改</el-button>-->
<!--                    <el-button type="danger" v-show="showDel" @click="delFunc(scope.row)" size="mini">删除</el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>

        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关
                闭
            </el-button>
        </el-row>

        <el-dialog
            width="30%"
            :title="innerModal.type == 1 ? '新增运营ASIN' : '修改运营ASIN'"
            :visible.sync="innerModal.visible"
            :before-close="closeInner"
            append-to-body>
            <el-form ref="formData" :model="query" :rules="rules" :inline="true" size="mini">
                <el-form-item label="运营ASIN:" class="query-form-item" prop="operator_asin">
                    <el-input style="width: 150px;" clearable v-model="query.operator_asin" placeholder="多个可以用','隔开"
                              size="mini"></el-input>
                </el-form-item>
            </el-form>

            <el-row style="margin-top:17px; ">
                <el-button style="float:right;margin-left:6px;" size="mini" type="success" plain
                           v-show="innerModal.type==1" @click="addOperatorAsin()" :loading="addLoading">新 增
                </el-button>
                <el-button style="float:right;margin-left:6px;" size="mini" type="primary" plain
                           v-show="innerModal.type==2" @click="updateFunc()" :loading="editLoading">修 改
                </el-button>
            </el-row>
        </el-dialog>

        <el-dialog
            title="提示" :visible.sync="noDialogVisible" width="30%" :before-close="noHandleCloseModal" append-to-body>
            <span style="margin-bottom: 20px">确认不再运营吗？</span>

            <el-form>
                <el-form-item label="不再运营原因:" class="query-form-item">
                    <el-input style="width: 170px;" clearable v-model="fail_reason" placeholder="请输入不再运营原因"
                              size="mini"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="noHandleCloseModal" size="mini">取 消</el-button>
                <el-button type="primary" @click="noOfficialOperation" size="mini">确 定</el-button>
              </span>
        </el-dialog>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {low_price_mall_operator_get_operating_asin} from '@/api/advAnalys/advAnalys.js'

export default {
    data() {
        return {
            fail_reason: '',
            tempDate: {},
            showEdit: false,
            noDialogVisible: false,
            isNeedRefresh: false,
            visible: false,

            addLoading: false,
            editLoading: false,
            innerModal: {
                visible: false,
                selInfo: {},
                type: 0,
            },
            tabsName: 'first',
            list: [],
            selectIds: 0,
            loading: false,
            query: {
                status: 1,
                operator_asin: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            rules: {
                operator_asin: [{required: true, message: '请输入运营ASIN', trigger: 'blur'},]
            },
        }
    },
    computed: {
        showDel() {
            return this.$checkPermission('admin/operation/index/delete_operator_asin')
        },
    },
    methods: {
        noOfficialOperation() {
            const arr = this.list.filter(item => {
                if (item.status == 1) {
                    return true
                }
            })
            let func = () => {
                api.operation_index_update_operation_status_to_fail({
                    id: this.tempDate.id,
                    fail_reason: this.fail_reason
                }).then((res) => {
                    if (res.success) {
                        this.$message.success('操作成功')
                        this.getCategoryList()
                        this.fail_reason = ''
                        this.noDialogVisible = false
                    } else {
                        this.$message.error(res.message)
                    }
                }).catch(() => {
                    this.noDialogVisible = false
                })
            }
            console.log('arr', this.list)
            if (arr.length == 1) {
                this.$confirm('本条记录不再运营后，由于没有正在运营中的运营Asin，记录将转入不再运营列表中，请确认是否不再运营？', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    func()
                }).catch(() => {
                })
            } else {
                func()
            }
        },
        noHandleCloseModal() {
            this.fail_reason = ''
            this.noDialogVisible = false
        },
        noActiveList(data) {
            this.tempDate = data
            this.noDialogVisible = true
        },
        showModal(id, noEditBtn = true) {
            this.showEdit = noEditBtn
            this.visible = true
            this.selectIds = id
            this.getCategoryList()
        },
        addOperatorAsin() {
            this.$refs['formData'].validate(valid => {
                if (valid) {
                    this.addLoading=true
                    api.low_price_mall_operator_again_add_operating_asin({
                        id: this.selectIds,
                        operator_asin: this.query.operator_asin,
                    }).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({message: '新增成功', type: 'success'})
                            this.isNeedRefresh = true
                            this.closeInner()
                            this.getCategoryList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请刷新页面！'
                        })
                    }).finally(()=>{
                        this.addLoading=false
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })

        },
        showInner(typeNum, selInfo) {
            this.innerModal.type = typeNum
            this.innerModal.visible = true
            if (typeNum == 2) {
                const info = JSON.parse(JSON.stringify(selInfo))
                this.query.operator_asin = info.asin
                this.innerModal.selInfo = info
            }
        },
        closeInner() {
            this.innerModal.visible = false
            this.query.operator_asin = ''
            this.query.status = 1
        },
        updateFunc() {
            this.editLoading = true
            api.operation_index_update_operator_asin({
                id: this.innerModal.selInfo.id,
                operator_asin: this.query.operator_asin
            }).then(res => {
                if (res.code === 0) {
                    this.$message({message: '修改成功', type: 'success'})
                    this.isNeedRefresh = true

                    this.closeInner()
                    this.getCategoryList()
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
                this.editLoading = false
            })
        },
        delFunc(data) {
            let tipTxt = '确定删除吗?'
            if (data.status == 1) {
                const arr = this.list.filter(item => {
                    if (item.status == 1) {
                        return true
                    }
                })
                if (arr.length == 1) {
                    tipTxt = '本条记录删除后，由于没有正在运营中的运营Asin，记录将转入不再运营列表中，请确认是否删除？'
                }
            }
            this.$confirm(tipTxt, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.operation_index_delete_operator_asin({id: data.id,}).then(res => {
                    if (res.code === 0) {
                        this.$message({message: '删除成功', type: 'success'})
                        this.isNeedRefresh = true
                        this.closeInner()
                        this.getCategoryList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).finally(() => {
                    this.loading = false
                })
            }).catch(() => {
            })
        },
        changeCheckBox(data, index) {
            for (const listIndex in this.list) {
                if (listIndex == index) {
                    this.$set(this.list[listIndex], 'selected', 1)
                } else {
                    this.$set(this.list[listIndex], 'selected', 0)
                }
            }
        },
        getCategoryList() {
            this.loading = true
            api.low_price_mall_operator_get_operating_asin({
                id: this.selectIds,
                operation_status: this.query.status
            }).then(res => {
                if (res.code === 0) {
                    this.list = (res.data || []).map(item => {
                        item.selected = false
                        return item
                    })
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        getRowKeys(row) {
            return row.id
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        chooseItem(data) {
            this.$emit('choose1688Info', data)
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.get1688List()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.get1688List()
        },
        get1688List() {
            this.loading = true
            api.cost_analysis_personal_get_ali_result_lists({id: this.copyData.id, ...this.query}).then(res => {
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.list = responseList
                    this.query.total = res.data.total || 0
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        dataMigrationFunc() {
            let ids = []
            this.list.forEach(item => {
                item.selected && ids.push(item.id)
            })
            if (ids.length == 0) {
                this.$message({type: 'error', message: '暂未选择人员'})
                return
            }
            let params = {
                ids: this.selectIds,
                developer_id: ids.toString(),
            }
            api.manager_cost_analysis_audit_review_first(params).then(res => {
                if (res.code === 0) {
                    this.$message.success(res.data)
                    this.handleClose(true)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(flag) {
            const refreshFlag = JSON.parse(JSON.stringify(this.isNeedRefresh))
            this.visible = false
            this.isNeedRefresh = false
            this.tabsName = 'first'
            this.list = []
            this.selectIds = 0
            this.$emit('refreshPage', refreshFlag)
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
